import http from './http'

class PayerGroup {
  get (id) {
    return http.get(`/payer_groups/${id}`)
  }

  fetch (params = {}) {
    return http.get('/payer_groups', { params: params })
  }

  save (payload) {
    return http.post(`/payer_groups`, { payer_group: payload })
  }

  update (payload) {
    return http.put(`/payer_groups/${payload.id}`, { payer_group: payload })
  }

  payers (id) {
    return http.get(`/payer_groups/${id}/payers`)
  }
}

export default new PayerGroup()



// WEBPACK FOOTER //
// ./src/services/payer_group.js